import Menu from '@/apiClient/Menu'
import menuOpts from '@/config/menu.json'
import { has, map, includes, some, toNumber, intersection, each } from "lodash";
import crypto from 'crypto-browserify';

const mn = new Menu()

import UserManagement from '@/apiClient/UserManagement'
import User from '@/apiClient/User'
import Auth from '@/apiClient/Auth'
import Employee from '@/apiClient/Employee'
import Onboarding from '@/apiClient/OnBoarding'
import Company from '@/apiClient/Company'
import VismaIntegration from '@/apiClient/VismaIntegration'
import i18n from '@/plugins/i18n'


const user = new User()
const auth = new Auth()
const ob = new Onboarding()
const userManagement = new UserManagement()
const employee = new Employee()
const vi = new VismaIntegration()

export default {
    setJwt: ({ state, commit }, payload) => {
        commit("SET_JWT", payload)
    },
    setUser: ({ state, commit }, payload) => {
        commit("SET_USER", payload)
    },
    setUserRelated: ({ state, commit }, payload) => {
        commit("SET_USER_RELATED", payload);
    },
    setHistoryUrl: ({ state, commit }, payload) => {
        commit("SET_HISTORY_URL", payload);
    },
    setMenu: ({ state, commit }, payload) => {
        commit('SET_MENU', payload);
    },
    setActions: ({ state, commit }, payload) => {
        commit('SET_ACTIONS', payload);
    },
    setJwtExpired: ({ state, commit }, payload) => {
        commit('SET_JWT_EXPIRED', payload);
    },
    setPermissions: ({ state, commit }, payload) => {
        commit('SET_PERMISSIONS', payload);
    },
    setSearchRRHH: ({ state, commit }, payload) => {
        commit('SET_SEARCH_EMPLOYEE_RRHH', payload);
    },
    setSearchDocumentRRHH: ({ state, commit }, payload) => {
        commit('SET_SEARCH_DOCUMENT_RRHH', payload);
    },
    setEstadoEmpresa: ({ state, commit }, payload) => {
        commit('SET_ESTADO_EMPRESA', payload);
    },
    setDropzoneImg: ({ state, commit }, payload) => {
        commit('SET_DROP_ZONE', payload);
    },
    setValidateSection: ({ state, commit }, payload) => {
        commit('SET_VALIDATE_SECTION', payload);
    },
    setSections: ({ state, commit }, payload) => {
        commit('SET_SECTIONS', payload);
    },
    resetStore: ({ commit }) => {
        commit('RESET_STORE');
    },
    setInitialMenu: async ({ commit }) => {
        const response = await mn.getUser()
        const data = response.status === 200 ? response.data.results.data : [];

        const fil = map(data, (n, i) => {
            return toNumber(n.id)
        })

        commit('SET_PERMISSIONS', { permissions: fil });

        const { menu, actions } = menuOpts[0]

        const actionsOpts = map(actions, (n, i) => {
            return toNumber(i)
        })

        const userActions = intersection(fil, actionsOpts)

        each(menu, function (a) {
            a.childsavailable = intersection(a.childs, userActions);
        });

        each(menu, function (a) {
            if (a.childsavailable.length > 0) {
                a.shown = some(a.childsavailable, action =>
                    includes(fil, toNumber(action))
                )
            } else {
                a.shown = fil.includes(a.id)
            }
        })


        each(actions, (action, clave) => {
            const menu = action[0]
            if (has(menu, "submenu")) {
                each(menu.submenu, (item) => {
                    if (includes(fil, toNumber(item.id))) {
                        item.shown = true;
                    }
                });
            }

        });

        commit('SET_MENU', { menu })
        commit('SET_ACTIONS', { actions })
    },
    setInitialCountry: async ({ commit ,dispatch}, payload) => {
        const { pais:country } = await  dispatch('getProfile')
        
        const locales = Object.keys(i18n.messages);

        const countryChosen = locales.includes(country.toLowerCase()) ? country.toLowerCase() : 'ar';

        i18n.locale = countryChosen;

        commit('SET_INITIAL_COUNTRY', countryChosen)
    },
    setLimit: ({ commit }, payload) => {
        commit('SET_LIMIT_BY_PAGE', payload)
    },
    setInitialOnBoardingList: async ({ commit }, payload) => {
        const { data } = await ob.getListTemplate()
        commit('SET_INITIAL_ONBOARDING_LIST', data)
    },
    setReactivateUser: ( { commit }, data) => {
        return new Promise( (resolve, reject) => {

            userManagement.putReactivateUser(data.idUser, data.recruitmentDate, data.email, data.organizationModel).then( response => {
                resolve(response.data)
            }).catch(e => {
                reject(e.response.data)
            })
        })
    },
    setUserList: ({ commit }, payload) => {
        commit('SET_USER_LIST', payload);
    },
    setActivateDate: ({ commit }, payload) => {
        commit('SET_ACTIVATE_DATE', payload);
    },
    setCarteleraHome: ({ commit }, payload) => {
        commit('SET_CARTELERA_HOME', payload);
    },
    setHomeSectoresBirthdays: ({ commit }, payload) => {
        commit('SET_HOME_SECTORES_BIRTHDAYS', payload);
    },
    setHomeSectoresRecentHired: ({ commit }, payload) => {
        commit('SET_HOME_SECTORES_RECENT_HIRED', payload);
    },
    setPopupMantenimientoVisualizations: ({ commit }, payload) => {
        commit('SET_POPUP_MANTENIMIENTO_VISUALIZATIONS', payload);
    },
    setPopupVismaVisualizations: ({ commit }, payload) => {
        commit('SET_POPUP_VISMA_VISUALIZATIONS', payload);
    },
    setMsgOutage: ({ commit }, payload) => {
        commit('SET_MSG_OUTAGE', payload);
    },
    setNotifyPushVisualizations: ({ commit }, payload) => {
        commit('SET_NOTIFY_PUSH_VISUALIZATIONS', payload);
    },
    setNotifyPush: ({ commit }, payload) => {
        commit('SET_NOTIFY_PUSH', payload);
    },
    setPopupFileUploadLicensesVisualizations: ({ commit }, payload) => {
        commit('SET_POPUP_FILE_UP_LICENSES', payload);
    },
    setSSOData: ({commit}, payload) => {
        commit('SET_SSO_DATA', payload)
    },
    ssoAuthentication: (_, ssoToken) => {
        return new Promise ((resolve, reject) => {
            auth.loginSSO(ssoToken).then(response => {
                resolve(response)
            }).catch(e => {
                reject(e)
            })
        })
    },
    setDocumentsWaiting: async ({ commit }, payload) => {
        try {
            const response = await employee.getDocumentWaitingPerPage(payload.perPage, payload.page, payload.orderParams)
            let data = {}
            if (response.status === 200) {
                data = {
                    pagination: response.data.pagination,
                    results: response.data.results
                }
                commit('SET_DOCUMENTS_WAITING', data)
            }
        } catch (error) {
            if (error.response.status === 404) {
                commit('SET_DOCUMENTS_WAITING', {})
            }
        }
    },
    setNewDocumentWaiting: async ({ commit }) => {
    try {
            const response = await employee.getNewDocumentWaitingPerPage()
            if (response.status === 200) {
                const data = {
                    pagination: response.data.data.rows.length,
                    results: response.data.data.rows
                }
                commit('SET_NEW_DOCUMENTS_WAITING', data)
            }
        } catch (error) {
            if (error.response.status === 404) {
                commit('SET_NEW_DOCUMENTS_WAITING', {})
            }
        }
    },
    setCompanyLogo:  ({commit}, id_company) => {
        const random = '?v=' + new Date().getTime()
        function md5(str) {
            const hash = crypto.createHash('md5');
            hash.update(str);
            return hash.digest('hex');
          }

        const id_company_md5 ='/' + md5(id_company.toString()) 
        const src = `${window.trcb.publicDevURL}/company/logo/${id_company + id_company_md5 + random}`
        
        const storedConfig = localStorage.getItem('navBarConfig')
        const navBarConfig = storedConfig ? { ...JSON.parse(storedConfig) } : {}

        localStorage.setItem('navBarConfig', JSON.stringify({...navBarConfig, companyLogo: src}))

      commit('SET_COMPANY_LOGO', src);
    },
    setParamLoginFactory: ({ commit }, factory) => {
        commit('SET_PARAM_FACTORY', factory)
    },
    getProfile: async ({ commit, state }) => {
        if (Object.keys(state.profile).length > 0) {
          return Promise.resolve(state.profile)
        } else {
          return user.getprofile()
            .then(response => {
              commit('SET_PROFILE', response.data.results.data[0])
              return response.data.results.data[0]
            })
        }
    },
    setCleanAction: async ({ commit }) => {
        const response = await mn.getUser()
        const data = response.status === 200 ? response.data.results.data : [];
        const action = data.map(item => item.id)
        commit('SET_CLEAN_ACTION',  action )
    },
    setPayrollStatus: async ({commit, state},   { replace = false }: { replace?: boolean } = {}) => {
        if (!replace && state.payrollStatus && Object.keys(state.payrollStatus).length > 0) { 
            return;
          }
          try {
            const response = await vi.getPayrollStatus();
            const payrollStatus = response.data.data;
            commit('SET_PAYROLL_STATUS', payrollStatus);
            
            if (payrollStatus.activate) {
                commit('UPDATE_PERMISSIONS', 'payroll');
            }
          } catch (e) {
            commit('SET_PAYROLL_STATUS', {});
          }
      },
}
